import mitt from "mitt";
import Util from "@/helper/Utility.js";

export function AlertBottomModalController() {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.busModal = mitt();

    this.callbackOk = null;
    this.callbackClose = null

    //#region setter
    this.clearModal = function () {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.callbackOk = null;
        this.callbackClose = null

        return this;
    };
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setMsg = function (msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function (btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function () {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }

        return this
    }
    this.sendCallbackOk = function (data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };

    this.onClose = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }

        return this
    }
    this.sendCallbackClose = function () {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose();
        }
    }
    //#endregion event
}
